<script setup>
  import { ref,computed, getCurrentInstance, onMounted } from 'vue'
  import { usePageLoadingStore } from '../../../../../stores/pageLoading';
  import { useRoute, useRouter } from 'vue-router';
  import _ from "lodash";
  import moment from "moment";
  import adminJobfairStateService from '../../../services/jobfair/adminJobfairStateService';
  import JobFairResumeDetailModal from '../../../../user/components/modal/jobFair/JobFairResumeDetailModal.vue';
  import JobFairJobNoticeDetailModal from '../../../../user/components/modal/jobFair/JobFairJobNoticeDetailModal.vue';
  import mypageJobFairApplicantService from '../../../../user/services/mypage/jobFair/mypageJobFairApplicantService';
  import KSATextButton from "../../../../../components/ui-components/button/KSATextButton.vue";

  const route = useRoute();
  const router = useRouter();
  const loadingStore = usePageLoadingStore();
  const { $pageListBoardNo, $toast, $number, $gbNameKR, $yyyymmddHHmmss, $interests, $applyStateGb, alert, confirm } = getCurrentInstance().appContext.config.globalProperties;

  const data_interests = ref($interests); // 관심 카테고리
  const data_applyStateGb = ref($applyStateGb); // 서류지원상태

  const currentPage = ref(1);
  const pageSize = ref(10);
  const totalPages = ref(0);
  const totalCount = ref(0);
  const list = ref([]);

  const jobNoticeModal = ref(null);
  const jobFairResumeModal = ref(null); // 이력서 보기

  // 검색
  const searchTypeRef = ref(null);
  const interestsListRef = ref(null);
  const applyStateGbsListRef = ref(null);

  // 검색조건 - 페이지 크기
  const pageSizeGroup = ref([
    { label:'10개씩 보기', value: '10' },
    { label:'30개씩 보기', value: '30' },
    { label:'50개씩 보기', value: '50' },
    { label:'100개씩 보기', value: '100' },
  ])

  const searchOpen = ref(true);

  const initSearchInputModel = { // 재직자/기업(1) - 입사지원(3)
    searchInterests: ['설계','장비','소재','제조공정','패키지','테스트','SW','기타'],
    searchApplyStateGbs: ['01', '02', '03', '04', '05', '06'],
    searchDurationType: 'all',
    startYmd: '',
    endYmd: '',
    searchType: 'name', // name 이름, id 아이디, rTitle 이력서 제목, jnTitle 채용공고제목, corpName 기업명
    searchInput: '',
  };

  const searchInput = ref({...initSearchInputModel});

  // 검색조건 - 날짜검색기준 (all 모든 기간, term 기간 검색)
  const searchDurationTypeGroup = ref([
    { label:'모든 기간', value: 'all' },
    { label:'기간 검색', value: 'term' },
  ])

  const searchTypeGroup = ref([
    { label:"이름", value: "name", placeholder: "이름을 입력해주세요."  },
    { label:"아이디", value: "id", placeholder: "아이디를 입력해주세요." },
    { label:"이력서 제목", value: "rTitle", placeholder: "이력서 제목을 입력해주세요." },
    { label:"채용공고 제목", value: "jnTitle", placeholder: "채용공고 제목을 입력해주세요."  },
    { label:"기업명", value: "corpName", placeholder: "기업명을 입력해주세요."  },
  ]);
  const searchInputPlaceholder = computed(()=>{
    const option = _.find(searchTypeGroup.value, { value: searchInput.value.searchType });
    if(option) {
      return option.placeholder;
    } else {
      return '';
    }
  })

  // 페이지 선택
  const onSelectPage = (pageNo) => {
    currentPage.value = pageNo;
    retrieveList();
  };

  // 페이지 사이즈 변경. 10,30,50,100
  const onSelectPageSize = (option) => {
    pageSize.value = option.value;
    currentPage.value = 1;
    retrieveList();
  }


  // 검색 - searchType 셀렉트 박스 선택시
  const onSelectSearchTypeGroup = (option) => {
    searchInput.value.searchType = option.value;
  }

  // 검색 - '초기화' 버튼 클릭
  const clearSearchInput = () => {
    searchInput.value = {...initSearchInputModel};
    interestsListRef.value?.initOptions();
    applyStateGbsListRef.value?.initOptions();
    searchTypeRef.value?.initSelectedOption(searchInput.value.searchType);
    // retrieveList();
  }

  // 검색 - '검색' 버튼 click
  const onClickSearch = () => {
    currentPage.value = 1;
    retrieveList();
  }

  const retrieveList = () => {
    const now = new Date();
    const startYmd = searchInput.value.startYmd ? searchInput.value.startYmd : moment(now).format('YYYYMMDD');
    const endYmd = searchInput.value.endYmd ? searchInput.value.endYmd : moment(new Date(now.setDate(now.getDate() + 30))).format('YYYYMMDD');

    const paramObj = {
      searchInterests: _.map(searchInput.value.searchInterests).join(','),
      searchApplyStateGbs: _.map(searchInput.value.searchApplyStateGbs).join(','),
      startYmd: searchInput.value.searchDurationType === 'all' ? '' : startYmd,
      endYmd: searchInput.value.searchDurationType === 'all' ? '' : endYmd,
      searchType: searchInput.value.searchType,
      searchInput: searchInput.value.searchInput,
      pageNumber: currentPage.value,
      size: pageSize.value,
    }
    loadingStore.loading = true;
    adminJobfairStateService.retrieveAllResumeListAdminPaging(paramObj)
      .then( async (res) => {
        loadingStore.loading = false;
        if (res.data.code.toLowerCase() === "success") {
          const result = res.data.result;
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          list.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        }
      })
      .catch((res) => {
        loadingStore.loading = false;
        $toast("error", res);
      });
  }


  // 이력서 보기
  const onClickMyResume = async (resumeId) => {
    await jobFairResumeModal.value.show({
      resumeId,
      showDeleteBtn: false,
    });
  }

  // 채용공고 보기
  const onClickJobNotice = async (jobNoticeSeq, corpId) => {
    await jobNoticeModal.value.show({
      jobNoticeSeq,
      corpId,
    });
  }


  // 입사지원 상태변경 joinStateGb
  const onClickApplyStateGb = async (resumeId, jobNoticeSeq, stateGb) => {
    let modalContent, okButtonText;
    if (stateGb === "02") {
      modalContent = ["지원취소 처리하시겠습니까?", "'지원취소'으로 상태가 변경됩니다."];
      okButtonText = "지원취소";
    } else if (stateGb === "03") {
      modalContent = ["서류합격 처리하시겠습니까?", "'서류합격'으로 상태가 변경됩니다."];
      okButtonText = "서류합격";
    } else if (stateGb === "04") {
      modalContent = ["서류불합격 처리하시겠습니까?", "'서류불합격'으로 상태가 변경됩니다."];
      okButtonText = "서류불합격";
    } else if (stateGb === "05") {
      modalContent = ["최종합격 처리하시겠습니까?", "'최종합격'으로 상태가 변경됩니다."];
      okButtonText = "최종합격";
    } else if (stateGb === "06") {
      modalContent = ["최종불합격 처리하시겠습니까?", "'최종불합격'으로 상태가 변경됩니다."];
      okButtonText = "최종불합격";
    }

    const ok = await confirm(modalContent, okButtonText);
    if(ok) {
      const paramObj = {
        resumeId,
        jobNoticeSeq,
        applyStateGb: stateGb,
      };

      mypageJobFairApplicantService.updateApplyStateGb(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            alert("변경하였습니다.");
            retrieveList();
          } else {
            alert("변경을 실패하였습니다.");
          }
        })
        .catch( (res) =>  {
          loadingStore.loading = false;
          alert("변경을 실패하였습니다.");
        });
    }
  }

  const openDetailInNewTab = (linkName, id, query = {}) => {
    const url = router.resolve({
      name: linkName,
      params: { id },
      query,
    }).href;

    window.open(url, '_blank');
  }

  onMounted(() => {
    retrieveList();
  })
</script>
<template>
  <div>
    <div class="filter-wrap" :class="{'open': searchOpen}">
      <p @click="searchOpen = !searchOpen">검색</p>
      <div class="filter">
        <dl>
          <dt style="display:block;"><span>관심 카테고리</span><br/><small style="font-weight: normal;">복수 선택 가능</small></dt>
          <dd>
            <KSACheckBoxGroup
              ref="interestsListRef"
              className="mr-md"
              name="interestsList"
              v-model="searchInput.searchInterests"
              :options="data_interests"
            />
          </dd>
        </dl>
        <dl>
          <dt style="display:block;">상태</dt>
          <dd>
            <KSACheckBoxGroup
              ref="applyStateGbsListRef"
              className="mr-md"
              name="applyStateGbsList"
              v-model="searchInput.searchApplyStateGbs"
              :options="data_applyStateGb"
            />
          </dd>
        </dl>
        <dl>
          <dt>입사 지원일</dt>
          <dd class="text-box">
            <div class="grid">
              <template v-for="group in searchDurationTypeGroup" key="item.value" >
                <KSARadioButton class="mr-md" :label="group.label" v-model="searchInput.searchDurationType" :value="group.value" />
              </template>
              <div style="display: inline-block;" v-if="searchInput.searchDurationType !== 'all'">
                <KSADatepickerTerms
                  :startDate="searchInput.startYmd"
                  :endDate="searchInput.endYmd"
                  @update:startDate="(value)=> searchInput.startYmd = value"
                  @update:endDate="(value)=> searchInput.endYmd = value"
                />
              </div>
            </div>
          </dd>
        </dl>
        <!-- name 이름, id 아이디, rTitle 이력서 제목, jnTitle 채용공고제목, corpName 기업명 검색 -->
        <dl>
          <dt>
            <KSASelect ref="searchTypeRef" :options="searchTypeGroup" class="select" @selectOption="onSelectSearchTypeGroup"/>
          </dt>
          <dd>
            <KSAInput class="text-box" v-model="searchInput.searchInput" :placeholder="searchInputPlaceholder" />
          </dd>
        </dl>
        <div class="btn-wrap">
          <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
          <KSAPrimaryButton text="검색" @click="onClickSearch" />
        </div>
      </div>
    </div>
    <!-- e: 검색 -->
    <!-- s: 버튼영역 -->
    <div class="list-top">
      <p>총 <span>{{ $number(totalCount)}}</span>개</p>
      <div>
        <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize" />
      </div>
    </div>
    <!-- e: 버튼영역 -->
    <div class="table-form">
      <table class="horizontal">
        <tr>
          <th>NO</th>
          <th>회원코드</th>
          <th>이름</th>
          <th>아이디</th>
          <th>이력서 제목</th>
          <th>관심 카테고리</th>
          <th>전공계열(주전공)</th>
          <th>입사지원 채용공고</th>
          <th>기업명</th>
          <th>입사지원일</th>
          <th>상태</th>
          <th>상태변경</th>
        </tr>
        <tr v-for="applicant in list">
          <td>{{ applicant.boardNo }}</td>
          <td>{{ applicant.userCd }}</td>
          <td class="clickable blue">
            <span @click="openDetailInNewTab('MemberDetail', applicant.userCd)">{{ applicant.userName }}</span>
          </td>
          <td>{{ applicant.userLoginId }}</td>
          <td class="text-overflow long-overflow">
            <span class="file blue" v-if="applicant.fileYn === 'Y'" v-for="resumeAttaches in applicant.resumeAttaches" @click="$downloadForPrivate({fileName:resumeAttaches.fileName, fileDir: resumeAttaches.fileDir })">
              {{ resumeAttaches.fileName }}
            </span>
            <span class="clickable blue" v-else @click="onClickMyResume(applicant.resumeId)">
              {{ applicant.title }}
            </span>
          </td>
          <td>
            <span v-if="applicant.fileYn === 'Y'">-</span>
            <span v-else>{{ applicant.interests }}</span>
          </td>
          <td>{{ $gbNameKR('MAJOR_GB', applicant.majorGb) }}</td>
          <td class="clickable blue text-overflow long-overflow" @click="onClickJobNotice(applicant.jobNoticeSeq, applicant.corpId)">{{ applicant.jobName }}</td>
          <td class="clickable blue text-overflow long-overflow">
            <span @click="openDetailInNewTab('CorporationDetail', applicant.corpId, { tab: 3, tab2: 'job-postings' })">{{ applicant.corpName }}</span>
          </td>
          <td>{{ $yyyymmddHHmmss(applicant.createDate) }}</td>
          <td>
            <span v-if="applicant.applyStateGb === '01'">{{ $gbNameKR('APPLY_STATE_GB',applicant.applyStateGb) }}</span>
            <span v-else-if="applicant.applyStateGb === '03' || applicant.applyStateGb === '05'" class="blue">{{ $gbNameKR('APPLY_STATE_GB',applicant.applyStateGb) }}</span>
            <span v-else-if="applicant.applyStateGb === '04' || applicant.applyStateGb === '06'" class="red">{{ $gbNameKR('APPLY_STATE_GB',applicant.applyStateGb) }}</span>
            <span v-else class="gray">{{ $gbNameKR('APPLY_STATE_GB',applicant.applyStateGb) }}</span>
          </td>
          <td>
            <div v-if="applicant.applyStateGb === '01'">
              <!-- 지원완료 -->
              <KSATextButton class="clickable black_button" text="서류합격" @click="onClickApplyStateGb(applicant.resumeId, applicant.jobNoticeSeq, '03')"/>
              &nbsp;
              <KSATextButton class="clickable black_button" text="서류불합격" @click="onClickApplyStateGb(applicant.resumeId, applicant.jobNoticeSeq, '04')"/>
            </div>
            <div v-else-if="applicant.applyStateGb === '03'">
              <!-- 서류합격 -->
              <KSATextButton class="clickable black_button" text="서류불합격" @click="onClickApplyStateGb(applicant.resumeId, applicant.jobNoticeSeq, '04')"/>
              <br/>
              <KSATextButton class="clickable black_button" text="최종합격" @click="onClickApplyStateGb(applicant.resumeId, applicant.jobNoticeSeq, '05')"/>
              &nbsp;
              <KSATextButton class="clickable black_button" text="최종불합격" @click="onClickApplyStateGb(applicant.resumeId, applicant.jobNoticeSeq, '06')"/>
            </div>
            <div v-else-if="applicant.applyStateGb === '04'">
              <!-- 서류불합격 -->
              <KSATextButton class="clickable black_button" text="서류합격" @click="onClickApplyStateGb(applicant.resumeId, applicant.jobNoticeSeq, '03')"/>
            </div>
            <div v-else-if="applicant.applyStateGb === '05'">
              <!-- 최종합격 -->
              <KSATextButton class="clickable black_button" text="최종불합격" @click="onClickApplyStateGb(applicant.resumeId, applicant.jobNoticeSeq, '06')"/>
            </div>
            <div v-else-if="applicant.applyStateGb === '06'">
              <!-- 최종불합격 -->
              <KSATextButton class="clickable black_button" text="최종합격" @click="onClickApplyStateGb(applicant.resumeId, applicant.jobNoticeSeq, '05')"/>
            </div>
            <div v-else>
              -
            </div>
          </td>
        </tr>
      </table>
      <div class="result-none" v-if="list.length === 0">
        입사지원 내역이 없습니다.
      </div>
    </div>
    <Paginate
      v-if="list.length > 0"
      v-model="currentPage"
      :page-count="totalPages"
      :click-handler="onSelectPage"
    />
  </div>
  <JobFairJobNoticeDetailModal ref="jobNoticeModal" /> <!-- 채용공고 보기 -->
  <JobFairResumeDetailModal ref="jobFairResumeModal" /> <!-- 이력서 보기 -->
</template>

<style lang="scss" scoped>
.file {
  cursor: pointer;
}
</style>